export default {
      id: "ic-misc-share-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-misc-share-usage",
      toString: function () {
        return this.url;
      }
    }